function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxNoEventsStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258.59 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 74") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.3,98.78a40.77,40.77,0,0,1-5.9,21.2A26.63,26.63,0,0,1,242.84,140a32.68,32.68,0,0,1-4.76,3.45l-.21.12-.38.23-.12.07h0c-.54.3-1.09.6-1.65.87a37.41,37.41,0,0,1-16.65,3.84H49q-2,0-4-.16a47.68,47.68,0,0,1-13.79-3.19q-1.29-.51-2.53-1.1l-1.17-.57-.72-.37a43,43,0,0,1-4.21-2.56A41.51,41.51,0,0,1,19,137.93c-7.68-6.59-12.44-15.72-12.44-25.78A40.75,40.75,0,0,1,0,89.86C0,67.48,17.89,49.33,40,49.33c.68,0,1.35,0,2,.06h.29A68.86,68.86,0,0,1,57,32.1c16.31-14,40.15-22.79,66.7-22.79,22.31,0,42.71,6.22,58.33,16.5a39.33,39.33,0,0,1,19.41-5.09c22.07,0,40,18.15,40,40.53a41.72,41.72,0,0,1-.23,4.24A40.64,40.64,0,0,1,258.3,98.78Z",
    style: {
      fill: "#6c63ff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.7,190.85c0,5-23.68,9.15-52.89,9.15s-52.89-4.1-52.89-9.15c0-1.26,1.48-2.46,4.15-3.56,7.79-3.19,25.71-5.45,46.78-5.58h2C112,181.71,135.7,185.81,135.7,190.85Z",
    style: {
      fill: "#3f3d56",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 23.33,
    cy: 23.56,
    r: 3.85,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.45,
    cy: 10.1,
    r: 3.85,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.98,
    cy: 71.09,
    r: 6.87,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.63,
    cy: 12.3,
    r: 1.65,
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.46,
    cy: 78.51,
    r: 1.65,
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.74,
    cy: 82.08,
    r: 1.65,
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.08,
    cy: 49.11,
    r: 1.65,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.38,
    cy: 12.3,
    r: 1.65,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.33,
    cy: 129.05,
    r: 1.65,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.66,
    cy: 113.12,
    r: 1.65,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.86,
    cy: 10.65,
    r: 1.65,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.41,41.7a4.12,4.12,0,1,1,4.12-4.12h0A4.13,4.13,0,0,1,199.41,41.7Zm0-7.69A3.57,3.57,0,1,0,203,37.57,3.57,3.57,0,0,0,199.41,34Z",
    style: {
      fill: "#bdccd4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.72,52.13a3,3,0,1,1,3-3h0A3,3,0,0,1,191.72,52.13Zm0-5.49a2.47,2.47,0,1,0,2.47,2.47A2.47,2.47,0,0,0,191.72,46.64Z",
    style: {
      fill: "#bdccd4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.75,66.69a3,3,0,1,1,3-3h0A3,3,0,0,1,208.75,66.69Zm0-5.49a2.47,2.47,0,1,0,2.47,2.47h0A2.48,2.48,0,0,0,208.75,61.2Z",
    style: {
      fill: "#bdccd4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,70.81a22.53,22.53,0,1,1,22.53-22.53h0A22.55,22.55,0,0,1,203.26,70.81Zm0-44.5a22,22,0,1,0,22,22,22,22,0,0,0-22-22Z",
    style: {
      fill: "#bdccd4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,57.35c-18.79,0-33.51-4-33.51-9.07,0-3,4.37-5.51,12.3-7.17l.11.54c-7.54,1.58-11.87,4-11.87,6.63,0,4.62,15.1,8.52,33,8.52s33-3.9,33-8.52c0-2.64-4.34-5.06-11.91-6.64l.11-.54c8,1.66,12.34,4.21,12.34,7.18C236.77,53.37,222,57.35,203.26,57.35Z",
    style: {
      fill: "#bdccd4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,144.49c-.76,0-1.53,0-2.29,0l0-.55c1.09,0,2.19,0,3.28,0v.55Zm4.33-.13,0-.55c1.09-.06,2.19-.15,3.27-.27l.06.55C192.88,144.21,191.77,144.3,190.67,144.37Zm-9.92-.09c-1.1-.08-2.2-.19-3.29-.33l.07-.55c1.08.13,2.18.24,3.27.32Zm16.49-.6-.08-.54c1.08-.16,2.17-.35,3.23-.57l.11.54C199.43,143.32,198.34,143.51,197.25,143.68Zm-23.06-.2c-1.08-.18-2.18-.39-3.25-.63l.12-.54c1.06.23,2.15.44,3.22.62Zm29.54-1.09-.13-.53c1.06-.26,2.13-.55,3.17-.86l.16.53C205.88,141.83,204.8,142.12,203.73,142.39Zm-36-.31c-1.06-.28-2.13-.59-3.18-.92l.17-.52c1,.33,2.1.64,3.15.92Zm42.35-1.57-.18-.52c1-.36,2.06-.74,3.08-1.15l.2.51C212.15,139.76,211.11,140.15,210.08,140.51Zm-48.66-.43c-1-.38-2.07-.79-3.08-1.22l.21-.51c1,.42,2,.83,3.06,1.21Zm54.8-2-.23-.5c1-.45,2-.93,3-1.42l.25.49C218.21,137.12,217.2,137.6,216.21,138.05Zm-60.9-.55c-1-.47-2-1-3-1.49l.26-.48c1,.51,2,1,2.93,1.48ZM222.09,135l-.27-.48c.95-.54,1.89-1.11,2.81-1.69l.29.46c-.92.58-1.88,1.16-2.83,1.7Zm-72.62-.66c-.94-.56-1.89-1.15-2.81-1.76l.3-.46c.91.6,1.85,1.19,2.78,1.74Zm78.21-2.87-.31-.45c.89-.62,1.78-1.28,2.65-1.94l.33.44c-.87.67-1.77,1.33-2.67,2Zm-83.74-.77c-.89-.64-1.77-1.32-2.63-2l.34-.43c.85.68,1.73,1.35,2.61,2Zm89-3.25-.35-.42c.83-.7,1.66-1.43,2.46-2.17l.37.4C234.58,126,233.75,126.78,232.91,127.49Zm-94.15-.88c-.83-.72-1.65-1.48-2.44-2.24l.38-.4c.79.75,1.6,1.5,2.42,2.22Zm99-3.62-.39-.39c.77-.78,1.52-1.58,2.25-2.39l.41.37c-.73.81-1.5,1.62-2.27,2.41ZM134,122c-.76-.8-1.51-1.62-2.22-2.45l.41-.36c.71.82,1.46,1.64,2.21,2.43Zm108.2-4-.42-.35c.69-.84,1.37-1.71,2-2.58l.44.33c-.66.88-1.34,1.76-2,2.6Zm-112.54-1c-.68-.86-1.35-1.75-2-2.64l.45-.32c.64.88,1.3,1.76,2,2.62Zm116.5-4.26-.45-.31c.61-.9,1.21-1.83,1.78-2.76l.47.29c-.58.94-1.18,1.87-1.8,2.78ZM125.8,111.67c-.6-.92-1.18-1.86-1.74-2.81l.47-.28c.55.94,1.13,1.88,1.73,2.79Zm123.83-4.54-.48-.27c.53-1,1-1.93,1.52-2.91l.49.24C250.67,105.19,250.15,106.18,249.62,107.14ZM122.44,106c-.51-1-1-2-1.48-3l.5-.23c.46,1,1,2,1.47,2.93Zm130.11-4.78-.5-.22c.44-1,.86-2,1.25-3l.51.2C253.42,99.16,253,100.19,252.56,101.2ZM119.63,100c-.42-1-.82-2-1.2-3.07l.52-.19c.37,1,.77,2,1.19,3.05Zm135.3-5-.52-.17c.34-1,.67-2.09,1-3.14l.53.15C255.6,92.91,255.28,94,254.93,95Zm-137.56-1.2c-.33-1-.63-2.12-.91-3.18l.53-.14c.28,1.05.58,2.12.91,3.16Zm139.35-5.16-.54-.12c.25-1.06.47-2.14.67-3.21l.54.1c-.2,1.08-.43,2.17-.67,3.24Zm-141-1.23c-.23-1.07-.44-2.17-.62-3.25l.54-.09c.18,1.08.38,2.16.61,3.23Zm142.23-5.27-.54-.07c.15-1.08.27-2.17.37-3.26l.55,0c-.1,1.1-.23,2.2-.37,3.29ZM114.61,80.88c-.13-1.09-.24-2.2-.32-3.29l.55,0c.08,1.09.19,2.19.31,3.27Zm143.91-5.33-.55,0c0-1.09.07-2.19.07-3.28h.55c0,1.1,0,2.21-.07,3.31ZM114.13,74.29c0-.67,0-1.36,0-2q0-.63,0-1.27h.55q0,.63,0,1.26c0,.68,0,1.36,0,2ZM258,71.48c0-1.09,0-2.19-.11-3.28l.55,0c.06,1.1.1,2.21.11,3.31ZM114.79,67.71l-.55,0c.07-1.1.16-2.21.28-3.3l.55.06C115,65.52,114.86,66.62,114.79,67.71Zm142.88-2.78c-.11-1.08-.25-2.18-.41-3.26l.54-.08c.16,1.09.3,2.19.41,3.28ZM115.5,61.19,115,61.1c.17-1.09.36-2.18.58-3.26l.54.11C115.86,59,115.66,60.11,115.5,61.19Zm141.22-2.75c-.21-1.07-.45-2.15-.7-3.21l.53-.13c.26,1.06.5,2.15.71,3.23ZM116.8,54.75l-.53-.13c.27-1.06.56-2.14.88-3.19l.53.16C117.36,52.63,117.06,53.7,116.8,54.75Zm138.36-2.7c-.31-1-.64-2.1-1-3.13l.52-.18c.36,1,.69,2.1,1,3.15Zm-136.47-3.6-.52-.18c.37-1,.76-2.08,1.17-3.1l.51.21C119.44,46.39,119.05,47.43,118.69,48.46ZM253,45.85c-.4-1-.83-2-1.28-3l.5-.23c.45,1,.88,2,1.29,3ZM121.16,42.36l-.5-.23c.46-1,.95-2,1.45-3l.49.25C122.1,40.37,121.61,41.37,121.16,42.36Zm129.18-2.48c-.49-1-1-1.94-1.55-2.89l.48-.27c.54,1,1.06,1.93,1.56,2.91ZM124.17,36.52l-.48-.27c.55-1,1.13-1.9,1.72-2.83l.46.3c-.59.92-1.16,1.87-1.7,2.81Zm122.94-2.34c-.58-.92-1.19-1.84-1.81-2.74l.45-.31c.62.9,1.24,1.83,1.82,2.76ZM127.71,31l-.45-.32c.63-.9,1.3-1.79,2-2.66l.43.34C129,29.2,128.34,30.09,127.71,31Zm115.67-2.2c-.66-.87-1.35-1.73-2-2.56l.42-.35c.7.84,1.4,1.71,2.07,2.58Zm-111.64-3-.42-.36c.71-.83,1.45-1.67,2.2-2.47l.4.37C133.17,24.14,132.44,25,131.73,25.79Zm107.43-2c-.74-.8-1.5-1.6-2.28-2.37l.39-.39c.78.77,1.55,1.57,2.29,2.38ZM136.21,21l-.38-.39c.79-.77,1.6-1.53,2.42-2.26l.37.41c-.81.72-1.62,1.48-2.4,2.24Zm98.29-1.86c-.81-.73-1.64-1.46-2.48-2.15l.35-.42c.84.7,1.69,1.43,2.5,2.17Zm-93.4-2.51-.35-.43c.85-.69,1.73-1.37,2.61-2l.33.44C142.82,15.26,141.95,15.93,141.11,16.62Zm88.34-1.68c-.87-.66-1.77-1.3-2.67-1.92l.31-.45c.91.62,1.81,1.27,2.69,1.93Zm-83.07-2.23-.31-.46c.91-.61,1.85-1.21,2.78-1.78l.29.47C148.21,11.51,147.28,12.11,146.38,12.72ZM224,11.24c-.93-.57-1.88-1.13-2.83-1.67l.27-.48c1,.53,1.92,1.1,2.86,1.68ZM152,9.31l-.26-.48c1-.53,1.95-1,2.93-1.52l.24.49c-1,.48-2,1-2.91,1.51ZM218.28,8c-1-.49-2-1-3-1.4l.22-.5c1,.44,2,.92,3,1.41ZM157.86,6.43l-.22-.5c1-.44,2-.85,3.06-1.24l.2.51C159.88,5.58,158.86,6,157.86,6.43Zm54.41-1.05c-1-.39-2.06-.77-3.09-1.12l.17-.52c1,.35,2.09.73,3.12,1.13ZM164,4.1l-.17-.52c1-.34,2.11-.66,3.17-1l.15.53C166.08,3.44,165,3.76,164,4.1Zm42-.82c-1-.3-2.12-.58-3.18-.83l.13-.53c1.07.25,2.15.53,3.2.83Zm-35.72-.94-.12-.54c1.07-.24,2.16-.47,3.24-.66l.1.54c-1.07.19-2.15.41-3.22.66Zm29.33-.57c-1.07-.2-2.16-.38-3.24-.53l.08-.54c1.09.15,2.19.33,3.26.54Zm-22.88-.6L176.7.64c1.09-.15,2.19-.27,3.29-.36l0,.55c-1.09.09-2.18.22-3.26.36ZM193.15.87c-1.08-.1-2.18-.18-3.27-.23l0-.55c1.1.05,2.21.13,3.3.24ZM183.31.61l0-.55c1,0,2-.06,3.06-.06h.25V.55h-.25c-1,0-2,0-3,.06Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.39,101.31a31.91,31.91,0,0,1,9-8,15.57,15.57,0,0,1,11.69-1.64,21.39,21.39,0,0,1,7.63,4.72c4.67,4,9,8.67,14.49,11.46s12.77,3.31,17.45-.72c3.7-3.19,5.28-8.72,9.7-10.8s9.41.15,13.84,2.06a115.71,115.71,0,0,0,18.58,6.22,40,40,0,0,0,13.14,1.42c4.41-.42,8.83-2.18,11.7-5.55",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.39,85.85h11.09a38.79,38.79,0,0,0,0-13.22H103.39A23.8,23.8,0,0,1,103.39,85.85Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.56,91.89H24.65a38.79,38.79,0,0,0,0-13.22H13.56A23.8,23.8,0,0,1,13.56,91.89Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.68,51.78h11.09a38.79,38.79,0,0,0,0-13.22H206.68A23.8,23.8,0,0,1,206.68,51.78Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.93 175.87 53.6 183.27 60.79 183.9 60.16 175.87 55.93 175.87",
    style: {
      fill: "#ffb9b9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.81 181.57 90.81 191.72 99.05 191.72 96.72 181.57 90.81 181.57",
    style: {
      fill: "#ffb9b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.43,107.81,58,139.94s-4.23,28.32-3.38,32.76-.21,5.07-.21,5.07h6.34s-.21-2.75,1.06-4,.63-5.07.63-5.07l16.06-49,9.09,27.48s1.48,30.22,1.69,30.65.85,6.13.85,6.13H98s-1.06-3.38.42-4.44,2.75-.21,1.48-2.11-1.69-4.23-1.27-5.28.42-5.28.42-5.28-.63-57.07-4.23-59S61.43,107.81,61.43,107.81Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,186.34a24.49,24.49,0,0,0-3.61-.36c0,.18-4.34,11.93,0,11.75s20.78-2.53,19.7-6.87-6.51-3.07-6.51-3.07l-4.88-2.71Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.46,182.6a24.5,24.5,0,0,1,3.61-.36c0,.18,4.34,11.93,0,11.75s-20.78-2.53-19.7-6.87S47.88,184,47.88,184l4.88-2.71Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.74,133.59H85.41a37.33,37.33,0,0,0,0-12.73H74.74A22.9,22.9,0,0,1,74.74,133.59Z",
    style: {
      fill: "#d0cde1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.63,134H82.3a37.34,37.34,0,0,0,0-12.73H71.63A22.9,22.9,0,0,1,71.63,134Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.81,
    cy: 39.11,
    r: 8.32,
    style: {
      fill: "#ffb9b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.21,38.06s-1.48,14.8-3.38,15.85S83.41,56,83.41,56s-4-13.53-2.75-14.8S72.21,38.06,72.21,38.06Z",
    style: {
      fill: "#ffb9b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,53.49S84,47.78,77.28,48.84s-11.62,2.33-11.62,2.33S55.3,56.66,55.08,61.1s3.8,21.14,3.8,21.14S60.79,109.5,61,109.5l35.72-.42L90.17,73.57Z",
    style: {
      fill: "#575a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.58,104.35c-1.37.37-3.73-.14-6.2-.95a76.88,76.88,0,0,1-9.12-3.83S58,93.44,53.61,90.27s-1.48-15.85-1.48-15.85l6.76,2.11-.42,7.82,16.7,10.78a37.67,37.67,0,0,1,7.73,1.55c2.81.92,5.54,2.36,6.53,4.57a4.28,4.28,0,0,1,.33,1.06A1.56,1.56,0,0,1,88.58,104.35Z",
    style: {
      fill: "#ffb9b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42,101.25c-.29,1.09-.58,2.14-.85,3.09-1.37.37-3.73-.14-6.2-.95l.51-6.72C85.71,97.6,88.44,99,89.42,101.25Z",
    style: {
      opacity: 0.15,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.37,70.4,85.1,81.6,83,109.24s-11.64,14-5.08,14.42,10.15-13.74,10.15-13.74,6.55-22.4,6.34-27.05,0-12.47,0-12.47Z",
    style: {
      fill: "#ffb9b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.21,38.18a2.17,2.17,0,0,0,.6-.36A1.74,1.74,0,0,0,89,36a3.54,3.54,0,0,1-.34-1.84c.07-.29.22-.55.27-.84a1.78,1.78,0,0,0-1.06-1.67c-.61-.34-1.32-.51-1.89-.91-.89-.61-1.38-1.68-2.28-2.27a5.5,5.5,0,0,0-3.05-.59H77.49c-1.64,0-3.44.06-4.66,1.16-.37.33-.67.75-1,1.07a22,22,0,0,1-2.62,1.47,4.55,4.55,0,0,0-2,3.83c0,1.39.71,2.75.53,4.13a10.58,10.58,0,0,0-.49,2.74,3.22,3.22,0,0,0,2.19,2.29c1,.4,2.16.55,3.16,1,.82.38,1.68,1,2.54.72a2.54,2.54,0,0,0,1.39-1.72A14,14,0,0,0,77.15,42a4.39,4.39,0,0,1,.56-1.91,2.2,2.2,0,0,1,2-.85c1.7.15,2.65,3,4.21,2.35.77-.34,1.37-1.35,2-1.9A10,10,0,0,1,88.21,38.18Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.62,59.2s-4.23,1.48-5.92,7.4a25.29,25.29,0,0,0-1.06,9.93L59.52,78Z",
    style: {
      fill: "#575a89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73,53.07s7.61-1.69,8.67,5.5a115,115,0,0,1,1.06,14.58s-7.19-3.38-10.36,0Z",
    style: {
      fill: "#575a89"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.46,
    y: 76.86,
    width: 7.42,
    height: 0.82,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.63,
    y: 83.72,
    width: 7.42,
    height: 0.82,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.46,
    y: 78.78,
    width: 7.42,
    height: 0.82,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.02,
    y: 41.7,
    width: 7.42,
    height: 0.82,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.02,
    y: 45.54,
    width: 7.42,
    height: 0.82,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.02,
    y: 43.62,
    width: 7.42,
    height: 0.82,
    style: {
      fill: "#f2f2f2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.4,170.52c0,10.33,6.48,18.68,14.48,18.68",
    style: {
      fill: "#46455b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89,189.2c0-10.44,7.23-18.89,16.16-18.89",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.65,171.46c0,9.81,4.13,17.75,9.24,17.75",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89,189.2c0-13.34,8.36-24.14,18.68-24.14",
    style: {
      fill: "#46455b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,189.33a7.53,7.53,0,0,0,2.67-.5c.62-.44,3.16-1,3.31-.26s3.09,3.52.77,3.53-5.39-.36-6-.74S125.84,189.33,125.84,189.33Z",
    style: {
      fill: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.63,191.86c-2.32,0-5.39-.36-6-.74s-.66-1.32-.72-1.79h-.07s.13,1.66.75,2,3.69.76,6,.74c.67,0,.9-.24.89-.6C133.39,191.72,133.13,191.85,132.63,191.86Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxNoEventsStream);
export default __webpack_public_path__ + "static/media/gfx-no-events-stream.c13cdc54279d5618bb33baa9e6c8ccb4.svg";
export { ForwardRef as ReactComponent };